import {
  Accordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
  withStyles,
} from '@material-ui/core';
import { ContentWrapperWidget, MainTemplate } from '../../components/layouts';
import { CreateCalendarMutationHookResult, useCalendarQuery, useCreateCalendarMutation } from '../../api';
import React, { ChangeEvent, FC, useState } from 'react';

import Analytics from '../../components/widgets/Events/Analytics';
import CalendarSportingEventList from '../../components/CalendarSportingEventList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MainInfo from '../../components/widgets/Events/MainInfo';
import { blue } from '@material-ui/core/colors';
import moment from 'moment';
import onExpand from '../../utils/onExpand';
import { usePermission } from '../../hooks/usePermission';
import { useRouteMatch } from 'react-router-dom';

type AccordionTypes = 'MainInfo' | 'Analytics' | 'SportingEventList' | undefined;

const AccordionSummary = withStyles({
  root: {
    backgroundColor: blue[700],
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    color: 'white',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary) as any;

// @TODO: Update View for Dialog request to Archive

const Single: FC<{}> = () => {
  const {
    params: { id },
  } = useRouteMatch();
  // const [page, setPage] = useState<number>(0);
  const [expanded, setExpanded] = useState<AccordionTypes>('MainInfo');

  const access = usePermission('directory', 'eventscalendar');
  // const style = useStyle();
  // const canAdd = true;
  const { data } = useCalendarQuery({ variables: { id }, fetchPolicy: 'no-cache' });
  const [create]: CreateCalendarMutationHookResult = useCreateCalendarMutation();
  const handleChangeAccordion = (panel: AccordionTypes) => (event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : undefined);
  };
  const OptionTitleArchive = data?.dirCalendar?.archive
    ? ` (В архиве с ${moment(data?.dirCalendar?.archive?.date).format('DD.MM.YYYY')})`
    : '';

  return (
    <MainTemplate pageName="" url="">
      <ContentWrapperWidget>
        {id === 'new' ? (
          <h2>Добавить новый календарь</h2>
        ) : (
          <h2>
            Календарь: {data?.dirCalendar?.fullName}
            {OptionTitleArchive}
          </h2>
        )}
        <Accordion expanded={expanded === 'MainInfo'} onChange={handleChangeAccordion('MainInfo')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Общая информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'MainInfo') && (
              <MainInfo
                id={data?.dirCalendar?.id || 'new'}
                readonly={!access.includes(2)}
                // onUpdate={(idPerson) => (id === 'new' ? create({ variables: { idPerson } }) : undefined)}
              />
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'SportingEventList'} onChange={handleChangeAccordion('SportingEventList')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Список мероприятий</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'SportingEventList') && (
              <CalendarSportingEventList id={data?.dirCalendar?.id || 'new'} isEkp />
            )}
          </AccordionDetails>
        </Accordion>
      </ContentWrapperWidget>
    </MainTemplate>
  );
};

export default Single;
